import { render } from "./ModalImportMarketplace.vue?vue&type=template&id=b74ffa9c"
import script from "./ModalImportMarketplace.vue?vue&type=script&lang=js"
export * from "./ModalImportMarketplace.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__